import { Injectable } from "@angular/core";

export enum EventTypes {
    ButtonClick = "button_click",
    PerformanceIndividualDropdownClick = "performance_individual_asset_dropdown_click",
    PerformanceClassificationDropdownClick = "performance_asset_classification_dropdown_click",
    PerformanceGeneralEngagementClick = "performance_general_engagement_click",
    PerformanceExportClick = "performance_export_click",
    PerformanceClassificationTabClick = 'performance_classification_tab_click',
}

@Injectable()
export class GoogleAnalyticsService {
    
    constructor() {
        // Suppress errors if the Google Analytics script has not been enabled
        if (!(<any>window).gtag) {
            (<any>window).gtag = function() {};
        }
    }

    public logButtonClick(buttonName: string) {
        this.logEvent(EventTypes.ButtonClick, { 'name': buttonName });
    }
    
    private logEvent(eventType: string, params: object) {
        (<any>window).gtag('event', eventType, params);
    }
    
    /// Performance Page User Engagement Metrics
    
    /*
     Under the 'Asset classification performance' tab, log user clicks on asset names to Google Analytics
    */
    public logClassificationDropdownClick(assetTab: string) {
        this.logEvent(EventTypes.PerformanceClassificationDropdownClick, {'name': assetTab});
    }

    /*
     Under the 'Asset performance' tab, log user clicks on asset names to Google Analytics
    */
    public logIndividualDropdownClick(assetTab: string) {
        this.logEvent(EventTypes.PerformanceIndividualDropdownClick, {'name': assetTab});
    }

    /*
     Under both performance tabs, log user clicks on any part of the table to Google Analytics
    */
    public logGeneralEngagementClick(assetTab: string) {
        this.logEvent(EventTypes.PerformanceGeneralEngagementClick, {'name': assetTab});
    }

    /*
     Log users switching their table view to the 'Asset classification performance' tab to Google Analytics
    */
    public logTabClick(tabName) {
        this.logEvent(EventTypes.PerformanceClassificationTabClick, {'name': tabName});
    }
    
    /*
     Log user clicks of the 'export to XLS' button to Google Analytics
    */
    public logExportClick() {
        this.logEvent(EventTypes.PerformanceExportClick, {});
    }
}
